








import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
  name: 'RadioButtonComponent'
})
export default class RadioButtonComponent extends Vue {
  public val: boolean = false;

  @Prop({required: false})
  public disabled: boolean;

  @Prop({required: true})
  public value: boolean;

  public created() {
    this.updateValue();
  }

  @Watch('value')
  public updateValue() {
    this.val = this.value;
  }

  public emitNewValue() {
    if (this.val)
      return;

    this.val = true;

    this.$emit('input', this.val);
    this.$emit('change', this.val)
  }
}
